import React from 'react';
import { Link } from 'react-router-dom';

const Payment = () => {
  return (
    <div className="min-h-screen bg-[#0A0E23] text-white py-24 px-4">
      <div className="max-w-4xl mx-auto">
        <Link to="/support" className="text-blue-500 hover:underline mb-8 inline-block">
          ← Destek Sayfasına Dön
        </Link>
        
        <h1 className="text-4xl font-bold mb-8">Ödeme İşlemleri 💳</h1>
        
        <div className="space-y-12">
          <section>
            <h2 className="text-2xl font-semibold mb-4">Ödeme Yöntemleri</h2>
            <p className="text-gray-300 mb-4">
              Kullanabileceğiniz ödeme seçenekleri:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-300">
              <li>Kredi/Banka Kartı</li>
              <li>Havale/EFT</li>
              <li>Otomatik Ödeme</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">Abonelik İptali</h2>
            <p className="text-gray-300 mb-4">
              İptal işlemi nasıl yapılır:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-300">
              <li>Hesap ayarlarına gidin</li>
              <li>Abonelikler sekmesini seçin</li>
              <li>İptal butonuna tıklayın</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Payment;